import { Model } from "@vuex-orm/core";
import BuildingOwnerVotingRight from "./BuildingOwnerVotingRight";
import BuildingOwner from "./BuildingOwner";
import BuildingLot from "./BuildingLot";

export default class BuildingOwnerBuildingLot extends Model {
  static get entity() {
    return "building_owner_building_lot";
  }
  // static get primaryKey() {
  //   return ["id" /* "building_owner_id", "building_lot_id" */];
  // }

  static fields() {
    return {
      id: this.attr(null),
      building_owner_id: this.attr(null),
      building_lot_id: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null), // ???: ..

      building_owner_voting_rights: this.hasMany(
        BuildingOwnerVotingRight,
        "building_owner_has_building_lot_id"
      ),
      building_lot: this.belongsTo(BuildingLot, "building_lot_id"),

      // HACK: article 22
      buildingOwner: this.belongsTo(BuildingOwner, "building_owner_id"),
      agency_id: this.attr(null),
    };
  }
}
